<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                :menu-listing="getMenuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view @dataLength="onDataLength"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'

export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/insights/activity-dashboard',
                    name: 'view-activity-dashboard',
                    permission: ['view-activity-dashboard'],
                    menuLabel: 'Activity Dashboard',
                    accountTypes: ['standard', 'premium', 'lite'],
                },
                // {
                //     anchorLink: '/insights/alerts',
                //     menuLabel: 'Alerts',
                //     name: 'view-alerts',
                //     permission: ['view-alerts'],
                //     dataLength: 0,
                //     accountTypes: ['standard', 'premium', 'lite'],
                // },
                {
                    anchorLink:
                        '/insights/idenfo-verification-tracker',
                    menuLabel: 'Verification Status',
                    name: 'view-customer-tracker',
                    permission: ['view-customer-tracker'],
                    accountTypes: ['standard', 'premium'],
                },
                {
                    anchorLink: '/insights/customer-statistics',
                    name: 'view-customer-statistics',
                    permission: ['view-customer-statistics'],
                    menuLabel: 'Customer Statistics',
                    accountTypes: ['standard', 'premium'],
                },
            ],
            dataLengthAlerts: 0,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId', 'user']),
        getMenuListing() {
            return this.menuListing.filter((item) =>
                item.accountTypes.includes(this.user.accountType)
            )
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        // this.getAlertsLength(this.dataSegmentId).then((dataLength) => {
        //     this.menuListing[1].dataLength = dataLength
        // })
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        onDataLength(value) {
            this.menuListing[1].dataLength = value
        },
        async getAlertsLength(dataSegmentId) {
            const { data } = await request({
                url: `/alerts/getLength/${dataSegmentId}`,
                method: 'get',
            })
            // this.menuListing[1].dataLength =  data.data
            return data.data
        },
    }, // End of Component > mounted
} // End of export default
</script>
